import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { mainGridGapColor } from '#/colors';
import InProgressIcon from '#/assets/InProgressIcon';

import { createWidget } from './charting';

interface Props {
  readonly className?: string;
  readonly symbol?: string;
}

export default function TradingView(props: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const isLoading = props.symbol == null;

  useEffect(() => {
    if (props.symbol == null) return;
    if (IS_RUNNING_IN_CYPRESS === 'true') return;
    createWidget({
      symbol: props.symbol,
      container: containerRef.current!,
    });
  }, [props.symbol]);

  return isLoading ? (
    <LoadingOverlayContainer />
  ) : (
    <Container ref={containerRef} className={props.className} />
  );
}

const Container = styled.div`
  border-bottom: 1px solid ${mainGridGapColor};
`;

const LoadingOverlayContainer = styled.div.attrs({
  children: <InProgressIcon size={22} />,
})`
  display: grid;
  place-items: center;
  height: 100%;
  width: 100%;
`;
